import { BlockingGate, BlockingModal } from '@/shared/components/BlockingGate';
import CustomButton from '@/shared/components/CustomButton';
import type { ReactNode } from 'react';
import { useIdentityVerification } from '../hooks/useIdentityVerification';

interface IdentityVerificationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

function IdentityVerificationModal({ isOpen, onConfirm }: IdentityVerificationModalProps) {
  return (
    <BlockingModal
      isOpen={isOpen}
      titleId="identity-verification-title"
      descriptionId="identity-verification-description"
      overlayClassName="opacity-90"
      dialogClassName="max-w-lg"
    >
      <div className="relative z-10 mb-7xl pb-4xl">
        <h2
          id="identity-verification-title"
          className="text-lg font-semibold text-text-primary-900 lg:text-xl"
        >
          احراز هویت
        </h2>
        <p
          id="identity-verification-description"
          className="mt-2xl text-sm text-text-tertiary-600"
        >
          ناشر گرامی با توجه به نیاز احراز هویت به منظور انجام عملیات های مالی، لطفا از طریق دکمه زیر
          اقدام به انجام فرآیند احراز هویت خود نمایید.
        </p>
      </div>

      <div className="relative z-10">
        <CustomButton variant="primary" size="lg" className="w-full" onClick={onConfirm}>
          شروع احراز هویت
        </CustomButton>
      </div>
    </BlockingModal>
  );
}

interface IdentityVerificationGateProps {
  children: ReactNode;
}

export default function IdentityVerificationGate({ children }: IdentityVerificationGateProps) {
  const { isBlocking, startVerification } = useIdentityVerification();

  return (
    <BlockingGate
      isActive={isBlocking}
      expectsDialog={isBlocking}
      dialog={<IdentityVerificationModal isOpen={isBlocking} onConfirm={startVerification} />}
    >
      {children}
    </BlockingGate>
  );
}
